import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 13/11;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-436.000000, -484.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 300.000000)">
                        <path d="M7.365,10.365 L7.365,9.135 L16.125,9.135 L16.125,10.365 L7.365,10.365 Z M7.365,14.115 L7.365,12.885 L16.125,12.885 L16.125,14.115 L7.365,14.115 Z M7.365,5.385 L16.125,5.385 L16.125,6.615 L7.365,6.615 L7.365,5.385 Z M4.26,9.135 L4.26,8.49 L6.135,8.49 L6.135,9.075 L4.995,10.365 L6.135,10.365 L6.135,11.01 L4.26,11.01 L4.26,10.425 L5.37,9.135 L4.26,9.135 Z M4.875,7.26 L4.875,5.385 L4.26,5.385 L4.26,4.74 L5.49,4.74 L5.49,7.26 L4.875,7.26 Z M4.26,12.885 L4.26,12.24 L6.135,12.24 L6.135,14.76 L4.26,14.76 L4.26,14.115 L5.49,14.115 L5.49,13.815 L4.875,13.815 L4.875,13.17 L5.49,13.17 L5.49,12.885 L4.26,12.885 Z" id="Ordered-list"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatOrderedList extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
